import { useState } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { listLogins } from "../api/activity";

export function ActivityPage() {
  const [page, setPage] = useState(1);
  const [username, setUsername] = useState("");
  const perPage = 50;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["activity-logins", page, username],
    queryFn: () => listLogins({ page, per_page: perPage, username: username || undefined }),
    placeholderData: keepPreviousData,
  });

  if (isLoading) return <p className="text-gray-500">Loading activity…</p>;
  if (isError) return <p className="text-red-600">{(error as Error).message}</p>;

  const rows = data?.data ?? [];
  const total = data?.total ?? 0;
  const totalPages = Math.max(1, Math.ceil(total / perPage));

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Activity Log</h1>
      <p className="text-sm text-gray-500 mb-4">Operator sign-in history.</p>

      <div className="mb-3">
        <input
          className="border border-gray-300 rounded px-3 py-2 text-sm w-64"
          placeholder="Filter by username…"
          value={username}
          onChange={(e) => {
            setPage(1);
            setUsername(e.target.value);
          }}
        />
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-gray-500">
            <tr>
              <th className="px-4 py-2">When</th>
              <th className="px-4 py-2">User</th>
              <th className="px-4 py-2">IP address</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((r) => (
              <tr key={r.login_event_id}>
                <td className="px-4 py-2 text-gray-600 font-mono">{r.created_at || "—"}</td>
                <td className="px-4 py-2 font-medium">{r.username || `User ${r.user_id ?? "?"}`}</td>
                <td className="px-4 py-2 font-mono text-gray-500">{r.remote_ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <p className="text-gray-400 text-sm p-4">No sign-in activity.</p>}
      </div>

      <div className="flex items-center justify-between mt-3 text-sm">
        <span className="text-gray-500">
          Page {page} of {totalPages} · {total} events
        </span>
        <div className="space-x-2">
          <button
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            className="px-3 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-40"
          >
            Previous
          </button>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
            className="px-3 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
